import { useExcelFileUploaderStore } from '@/stores/import/excelFileUploaderStore'

function ExcelFilePreviewDataTableBodyCell({
  text,
  i,
}: {
  text: string | number | boolean | null
  i: number
}) {
  const { previewDataColumnMapping, currentIncludedSheet } =
    useExcelFileUploaderStore((state) => state)

  return (
    <>
      {currentIncludedSheet &&
      Object.values(previewDataColumnMapping[currentIncludedSheet]).includes(
        i + 1
      ) ? (
        <div>{text}</div>
      ) : (
        <>{text}</>
      )}
    </>
  )
}

export default ExcelFilePreviewDataTableBodyCell
